import { ErrorMessage, Field, useField } from 'formik';
import React from 'react';

export interface FormTextareaProps {
  name: string;
  label: string;
  rows?: number;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  hint?: string;
  className?: string;
  id?: string;
}

const FormTextarea: React.FC<FormTextareaProps> = ({
  name,
  label,
  rows = 4,
  placeholder,
  required,
  disabled,
  hint,
  className = '',
  id,
}) => {
  const [, meta] = useField(name);
  const hasError = meta.touched && !!meta.error;
  const fieldId = id || `textarea-${name}`;

  return (
    <div className={className}>
      {/* Label */}
      <label
        htmlFor={fieldId}
        className={`block text-sm font-normal mb-2 ${
          hasError ? 'text-error-500' : 'text-monday-text-muted'
        }`}
      >
        {label}
        {required && <span className="form-required-dot"></span>}
      </label>

      {/* Textarea */}
      <Field
        as="textarea"
        name={name}
        id={fieldId}
        rows={rows}
        placeholder={placeholder}
        disabled={disabled}
        className={`
          mobile-form-input
          w-full
          resize-y
          ${hasError ? 'border-red-500' : ''}
        `}
      />

      {/* Error Message */}
      <ErrorMessage name={name} component="div" className="text-red-500 text-xs mt-1" />

      {/* Hint */}
      {hint && !hasError && (
        <p className="mt-1 text-xs text-monday-text-muted">{hint}</p>
      )}
    </div>
  );
};

export default FormTextarea;
